// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"b87c385f","410":"52adce14","440":"02923327","455":"38387e36","488":"fcdb433f","503":"815518d2","593":"5bb22ecb","612":"92c50a71","733":"dbf496d4","804":"2ab74e2f","860":"73176ee8","883":"42648a70","953":"f5d7c640","977":"fbbe4a52"}[chunkId] + ".chunk.js";
};